<template>
  <tr>
    <td
      class="boss-table-data"
      data-test="job-id"
    >
      {{ job.id }}
    </td>
    <td
      class="boss-table-data"
      data-test="job-admin-name"
    >
      {{ job.adminName }}
    </td>
    <td
      class="boss-table-data left"
      data-test="job-name"
    >
      {{ job.name }}
    </td>
    <td
      class="boss-table-data"
      data-test="publish-date"
    >
      {{ job.startDate | formatDate }} ~ {{ job.endDate | formatDate }}
    </td>
    <td
      class="boss-table-data"
      data-test="publish-plan"
    >
      {{ job.plan }}
    </td>
    <td class="boss-table-data">
      <div>
        <button
          class="boss-button"
          data-test="job-preview-button"
          @click="windowOpenPreview('jobPublishedPreview')"
        >
          求人
        </button>
      </div>
      <div class="pega-mt-05">
        <button
          class="boss-button pega-width-5-5rem"
          data-test="job-search-preview-button"
          @click="windowOpenPreview('jobSearchPublishedPreview')"
        >
          検索一覧
        </button>
      </div>
    </td>
    <td
      v-if="isPublishing"
      class="boss-table-data"
    >
      <span
        v-if="job.isOriginalEntryForm"
        data-test="job-original-entry-type"
      >専用応募フォーム</span>
      <select
        v-else
        :value="job.isSimple"
        data-test="job-entry-type"
        class="boss-input-select js-check-default"
        @change="updateEntryType"
      >
        <option :value="true">
          自己PR不要
        </option>
        <option :value="false">
          通常
        </option>
      </select>
    </td>
  </tr>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val) {
      return dayjs(val).format('YYYY/MM/DD')
    }
  },
  props: {
    job: {
      type: Object,
      required: true
    },
    isPublishing: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    updateEntryType () {
      const isSimple = !this.job.isSimple
      this.$http.secured.patch(`/preview/publish/jobs/${this.job.offerId}/entry_form_type`, isSimple).then(() => {
        this.$toasted.global.success({ message: '応募フォームタイプを変更しました。' })
        this.$emit('updateEntryType', this.job.id, isSimple)
      })
    },
    windowOpenPreview (name) {
      const routeData = this.$router.resolve({ name: name, params: { offerId: this.job.offerId } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
